export class Controller {

    /** @ngInject */
    constructor(
    		Alert,
    		UsersResource,
    ) {
        this.Alert = Alert;
        this.UsersResource = UsersResource;
    }

    $onInit() {
    }
    
    unblock(account) {
        this.isUnblocking = true;
        this.UsersResource
            .unblockCompanyUser(this.companyId, account.id)
            .then(() => {
            	var index = this.blockedUsers.indexOf(account);
            	this.blockedUsers.splice(index,1);
                this.numberOfUsers.blockedUsers -= 1;
                account.blocked = 'NONE';
                this.Alert('success', 'company.user-directories.manage-user.unblocked');
            })
            .finally(() => this.isUnblocking = false)

    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/blocked-users/blocked-users.controller.js